import { baseEnvironment } from './environment.base';

const specificEnvironment = {
  deeplinkUrl: 'https://www.mobielschademelden.nl',
  endpointUrl: 'https://apidenit.msmplatform.nl/v3',
  environment: 'production',
  production: true,
  viaServerUrl: 'https://apidenit.msmplatform.nl/v2/viaGeoCoding',
};

export const environment = { ...baseEnvironment, ...specificEnvironment };
